export class BusinessTimeInfo {
    dt_Monday: string | undefined;
    dt_Tuesday: string | undefined; 
    dt_Wednesday: string | undefined; 
    dt_Thursday: string | undefined; 
    dt_Friday: string | undefined; 
    dt_Saturday: string | undefined;
    dt_Sunday: any | undefined; 
    status?:boolean;
}
